export default "__VITE_ASSET__B0WY91$2__"